var _defs, _path, _polygon, _polygon2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinkbow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_5",
    "data-name": "Layer 5",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 208.82 168.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ee499a;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M290.59,258l-13.87-26.68-13.88-26.68a11.79,11.79,0,0,0-20.4-.9l-16.17,25.36-14.62,22.93a34.5,34.5,0,0,0-59.08,29.2l-26.65-2.34-30-2.64A11.79,11.79,0,0,0,84.24,293l12.7,27.26,12.69,27.27A11.79,11.79,0,0,0,130,349.33l17.26-24.63,16.3-23.25A34.5,34.5,0,0,0,221,272.68l28.57,1.25,30.05,1.33A11.79,11.79,0,0,0,290.59,258Z",
    transform: "translate(-83.12 -198.33)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "91.88 105.17 89.88 168.17 98.66 151.64 111.88 164.17 105.88 101.17 91.88 105.17"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "122.06 101.17 148.06 151.64 148.06 131.12 172.98 139.06 129.91 90.37 122.06 101.17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinkbow);
export default __webpack_public_path__ + "static/media/pink bow.9c1bdee3.svg";
export { ForwardRef as ReactComponent };